// extracted by mini-css-extract-plugin
export var leftAlign = "_u-2";
export var popper = "_u-0";
export var subtitle = "_u-1";